import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ListingDataSource, ListingPayload } from '@portal/shared/types/listing.types';
import { FieldOperationsSensorsList } from './field-operations-sensors.types';

@Injectable()
export class FieldOperationsSensorsListingDataSourceService implements ListingDataSource<FieldOperationsSensorsList> {
  total = 0;

  // TODO(#799932): connect to the Sensors field operations table endpoint (aclara.field_operations_view, DeviceType IN [ExactaGuardGateway, RMDSensor]); format `lastFieldOperationDate` with TimezoneService like the Metering listing does
  getAll(_tableState: ListingPayload): Observable<FieldOperationsSensorsList> {
    return of({ data: [], total: 0 });
  }
}
